(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wly-footer"]) return;
  try {
    
  (function () {
    function openCookieSettings() {
      if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === 'function') {
        window.OneTrust.ToggleInfoDisplay();
        return true;
      }
      var btn = document.querySelector('.ot-floating-button__open, #ot-sdk-btn, .ot-sdk-show-settings');
      if (btn && !btn.hasAttribute('data-wly-cookie-settings')) {
        btn.click();
        return true;
      }
      return false;
    }
    document.addEventListener('click', function (e) {
      var target = e.target.closest ? e.target.closest('[data-wly-cookie-settings]') : null;
      if (!target) return;
      e.preventDefault();
      openCookieSettings();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
